import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-sun',
	templateUrl: './icon-sun.component.svg',
})
export class IconSunComponent {}
